/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {DrawSVGPlugin} from 'gsap/DrawSVGPlugin.js';
import {CustomEase} from 'gsap/CustomEase.js';
gsap.registerPlugin( DrawSVGPlugin );
gsap.registerPlugin( ScrollTrigger );
gsap.registerPlugin( CustomEase );

( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'click', ( event ) => {
        if ( window.innerWidth >= 630 ) {
          if ( $( '.dropdown-menu' ).hasClass( 'is-open' ) ) {
            $( '.dropdown-menu' ).removeClass( 'is-open' );
            $( '.navbar-toggle' ).removeClass( 'is-open' );

            gsap.to( '.dropdown-menu__main', {
              maxHeight: 0,
              duration: 1.5,
              ease: 'power4',
            } );

            gsap.to( '.nav__case-studies_featured', {
              clipPath: 'polygon(0px 0px, 0px 0px, 0px 100%, 0px 100%)',
              duration: 1.5,
              ease: 'power4',
            } );

            gsap.to( '.nav__case-studies_all', {
              clipPath: 'polygon(0px 100%, 100% 100%, 100% 100%, 0px 100%)',
              duration: 1.5,
              ease: 'power4',
            } );
          } else {
            $( '.dropdown-menu' ).addClass( 'is-open' );
            $( '.navbar-toggle' ).addClass( 'is-open' );

            gsap.to( '.dropdown-menu__main', {
              maxHeight: '100%',
              duration: 1.5,
              ease: 'power4.inOut',
            } );

            gsap.to( '.nav__case-studies_featured', {
              clipPath: 'polygon(0px 0px, 100% 0px, 100% 100%, 0px 100%)',
              duration: 1.5,
              ease: 'power4.inOut',
            } );

            gsap.to( '.nav__case-studies_all', {
              clipPath: 'polygon(0px 0px, 100% 0px, 100% 100%, 0px 100%)',
              duration: 1.5,
              ease: 'power4.inOut',
            } );
          }
        } else {
          if ( $( '.dropdown-menu' ).hasClass( 'is-open' ) ) {
            $( '.dropdown-menu' ).removeClass( 'is-open' );
            $( '.navbar-toggle' ).removeClass( 'is-open' );
          } else {
            $( '.dropdown-menu' ).addClass( 'is-open' );
            $( '.navbar-toggle' ).addClass( 'is-open' );
          }
        }
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        // $( '.dropdown-menu' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .dropdown-menu' ).removeClass( 'is-open' );
      } );

      const heroSVG = document.querySelectorAll( '.hero-logo-svg .hero_path' );

      heroSVG.forEach( ( el ) => {
        gsap.to( el, {
          drawSVG: '100%',
          duration: 2,
          delay: 1,
          ease: CustomEase.create( 'custom', 'M0,0 C0.51,0.22 0.492,1 1,1 ' ),
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
          },
        } );
      } );

      // Blog Sidebar Stickiness
      // if ( document.querySelector( '.ll-blog-sidebar' ) ) {
      //   const sticky = document.querySelector( '.ll-blog-sidebar' );
      //   let top = 0;

      //   if ( $( '#wpadminbar' ).length ) {
      //     top += $( '#wpadminbar' ).outerHeight();
      //   }

      //   const setSticky = () => {
      //     gsap.to( sticky, {
      //       scrollTrigger: {
      //         trigger: sticky,
      //         start: 'top ' + top + 'px',
      //         end: 'max',
      //         pin: sticky,
      //         pinSpacing: false,
      //         scrub: 0,
      //       },
      //     } );
      //   };

      //   setSticky();
      //   window.addEventListener( 'resize', setSticky );
      // }

      // $( 'body' ).children().each( function() {
      //   $( this ).html( $( this ).html().replace( /&#8232;/g, '' ) );
      // } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
